<div class="filter-list" [ngClass]="isRtl ? 'ar-mode' : 'en-mode'" [class.show]="isFilterPanelOpen">
    <div class="filter-header d-flex align-items-center justify-content-between">
        <h5 class="m-0 font-weight-bold">{{ 'searchBar.advanced' | translate }}</h5>
        <button type="button" class="btn-close-panel" (click)="onClose()" aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    </div>
    
    @for (group of filterGroups; track group.key) {
        <app-filter-group
            class="filter-item w-100"
            [group]="group"
            (toggle)="onFilterToggle(group.key, $event)"
            (search)="onSearchFacet(group.key, $event)"
            (loadMore)="onLoadMoreFacet(group.key)">
        </app-filter-group>
    }
 
    <div class="filter-date">
      <label class="d-block">{{ 'FILTERS.PUBLICATION_YEAR' | translate }}</label>
      <div class="search-input">
        <input type="text" placeholder="يوم/شهر/سنة" class="w-100" />
      </div>
    </div>

    <div class="filter-actions mt-4 pt-3 border-top">
        <button type="button" class="btn-filter" (click)="applyFilters.emit(); onClose()" translate="FILTERS.APPLY_SELECTIONS"></button>
        <button type="button" class="btn-reset" (click)="onClearAll()" translate="FILTERS.CLEAR_ALL"></button>
        <button type="button" class="btn-cancel" (click)="onClose()" translate="COMMON.CANCEL"></button>
    </div>
</div>